var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            {
              attrs: { xs12: "", "offset-xs0": "", md8: "", "offset-md2": "" }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    to: "/customers/new",
                    fab: "",
                    fixed: "",
                    bottom: "",
                    right: "",
                    color: "primary"
                  }
                },
                [_c("v-icon", [_vm._v("add")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "search",
                          label: "Search",
                          "single-line": "",
                          "hide-details": ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.searchCustomers()
                          }
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-data-table",
                    {
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.customers,
                        loading: _vm.customersLoading,
                        pagination: _vm.pagination,
                        "total-items": _vm.totalCustomers,
                        "rows-per-page-items": _vm.rowsPerPageItems
                      },
                      on: {
                        "update:pagination": function($event) {
                          _vm.pagination = $event
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("td", [
                                _vm._v(
                                  _vm._s(props.item.firstName) +
                                    " " +
                                    _vm._s(props.item.lastName)
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.quotes))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(props.item.freeSamples))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(props.item.orders))]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: [
                                        {
                                          text: "View Customer",
                                          value: {
                                            action: "view",
                                            id: props.item._id
                                          }
                                        },
                                        {
                                          text: "Delete",
                                          value: {
                                            action: "delete",
                                            id: props.item._id
                                          }
                                        }
                                      ],
                                      label: "Actions"
                                    },
                                    on: { change: _vm.customerActions }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _c("v-progress-linear", {
                        attrs: {
                          slot: "progress",
                          color: "primary",
                          indeterminate: ""
                        },
                        slot: "progress"
                      }),
                      _vm._v(" "),
                      _vm._v(" "),
                      _c("template", { slot: "no-data" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.loadingText) +
                            "\n          "
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bfc80ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bfc80ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customers/Customers.vue
// module id = null
// module chunks = 